import { render } from "./DoctorDetail.vue?vue&type=template&id=de13bf7a"
import script from "./DoctorDetail.vue?vue&type=script&lang=js"
export * from "./DoctorDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__